import InterfaceSkDiagnosa from "../apiInterface/InterfaceSkDiagnosa";
import { join, values, mapValues } from "lodash";
import ErrorAlert from "@/utility/ErrorAlert";

class DataSkDiagnosa {
  async getDataSkDiagnosa(reg) {
    // let dt: object = {}
    let dt: any
    await InterfaceSkDiagnosa.getSkDiagnosa(reg).then((response) => {
      dt = response.data
      // console.log(dt)
    })
      .catch((e) => {
        // dt = e.response
        // console.log(e);
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Suket Diagnosa")
      });
    return dt
  }

  async getDataSkDiagnosabyID(id) {
    // let dt: object = {}
    let dt: any
    await InterfaceSkDiagnosa.getSkDiagnosaByID(id).then((response) => {
      dt = response.data
      // console.log(dt)
    })
      .catch((e) => {
        // dt = e.response
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Suket Diagnosa")
        // console.log(e);
      });
    return dt
  }

  async saveDataTtdSkDiagnosa(id, user_id, password) {
    let dt: object = {}
    await InterfaceSkDiagnosa.saveTtdSkDiagnosa(id, user_id, password).then((response) => {
      dt = response.data
      // console.log(dt)
    })
      .catch((e) => {
        dt = e.response
        // ErrorAlert.showErrorAlert(e)
        // let message = "";
        // if (dt['status'] == 422) {
        //   message = join(
        //     values(
        //       mapValues(e.response.data.errors, function (val) {
        //         return join(val, "; ");
        //       })
        //     ),
        //     "; "
        //   );
        //   dt = { status: 0, err: "ERR 422 : " + e.response.data.message + " (" + message + ")" }
        //   // dt = { status: 0, err: "ERR 422 : " + e.response.data.message }
        // } else {
        //   dt = { data: dt, status: dt['status'], err: "ERR " + e.response.status + " : " + e.response.data.message }
        // }
      });
    // console.log(dt);
    return dt
  }

  async saveDataSkDiagnosa(reg,
    rm,
    dpjp_id,
    unit_id,
    diagnosis,
    tindak_lanjut_id,
    klinik_tujuan_id) {
    let dt: object = {}
    await InterfaceSkDiagnosa.saveSkDiagnosa(reg, rm,
      dpjp_id,
      unit_id,
      diagnosis,
      tindak_lanjut_id,
      klinik_tujuan_id).then((response) => {
        dt = response.data
        // console.log(dt)
      })
      .catch((e) => {
        dt = e.response
        ErrorAlert.showErrorAlert(e)
        // let message = "";
        // if (dt['status'] == 422) {
        //   message = join(
        //     values(
        //       mapValues(e.response.data.errors, function (val) {
        //         return join(val, "; ");
        //       })
        //     ),
        //     "; "
        //   );
        //   dt = { status: 0, err: "ERR 422 : " + e.response.data.message + " (" + message + ")" }
        //   // dt = { status: 0, err: "ERR 422 : " + e.response.data.message }
        // } else {
        //   dt = { data: dt, status: dt['status'], err: "ERR " + e.response.status + " : " + e.response.data.message }
        // }
      });
    return dt
  }

  async changeDataSkDiagnosa(id,
    reg,
    rm,
    dpjp_id,
    unit_id,
    diagnosis,
    tindak_lanjut_id,
    klinik_tujuan_id) {
    let dt: object = {}
    await InterfaceSkDiagnosa.changeSkDiagnosa(id,
      reg,
      rm,
      dpjp_id,
      unit_id,
      diagnosis,
      tindak_lanjut_id,
      klinik_tujuan_id).then((response) => {
        dt = response.data
        // console.log(dt)
      })
      .catch((e) => {
        dt = e.response
        ErrorAlert.showErrorAlert(e)
        // let message = "";
        // if (dt['status'] == 422) {
        //   message = join(
        //     values(
        //       mapValues(e.response.data.errors, function (val) {
        //         return join(val, "; ");
        //       })
        //     ),
        //     "; "
        //   );
        //   dt = { status: 0, err: "ERR 422 : " + e.response.data.message + " (" + message + ")" }
        //   // dt = { status: 0, err: "ERR 422 : " + e.response.data.message }
        // } else {
        //   dt = { data: dt, status: dt['status'], err: "ERR " + e.response.status + " : " + e.response.data.message }
        // }
      });
    return dt
  }

}

export default new DataSkDiagnosa();